"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeLinearProgressStyling = function () {
    var theme = (0, react_1.useTheme)();
    var _a = theme.mvf.palette.component, progressBarFilledColor = _a.progressBarFilledColor, progressBarUnfilledColor = _a.progressBarUnfilledColor;
    return (0, react_1.css)({
        backgroundColor: progressBarUnfilledColor,
        '& .MuiLinearProgress-barColorPrimary': {
            backgroundColor: progressBarFilledColor,
        },
    });
};
exports.default = makeLinearProgressStyling;
//# sourceMappingURL=makeLinearProgressStyling.js.map